<template>
  <div class="w-full">
    <NuxtLink
      :to="linkUrl"
      external
      :class="[
        backgroundClass ?? 'bg-surface-secondary',
        'py-18',
        'px-16',
        'rounded-md',
        'border-solid',
        'border-1',
        'border-border-tertiary',
        'flex',
        'flex-row',
        'gap-16 ',
        'my-16',
        'hover:bg-surface-action-hover',
        'active:shadow-buttonSoft',
        'no-underline',
        'focus-rounded',
      ]"
    >
      <nuxt-icon filled :name="icon" class="text-[4.8rem]" aria-hidden="true" />
      <div>
        <p class="heading-xxs text-text-on-highlight">{{ heading }}</p>
        <p class="text-text-on-highlight">{{ text }}</p>
      </div>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  linkUrl: string;
  icon: string;
  heading: string;
  text?: string;
  backgroundClass?: string;
}>();
</script>

<style lang="scss" scoped></style>
